import React from 'react';

export default function ProBadge() {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        color: '#7a5b00',
        background: '#f4e7b8',
        borderRadius: 999,
        padding: '2px 7px',
        lineHeight: 1.4,
      }}
    >
      PRO
    </span>
  );
}
